<template>
  <div>
    <Account :uid="$route.params.id"/>
  </div>
</template>

<script>
import DateFilter from "./DateFilter";
import Account from "./views/Account";
export default {
  name: "CustomerTransactions",
  components: {Account, DateFilter},
  data() {
    return {
      startDate: moment(new Date(new Date().setDate(new Date().getDate() - 30))).format("YYYY-MM-DD"),
      endDate: moment(new Date()).format("YYYY-MM-DD"),
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/CustomerTransactions.vue